/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_PartnershipInputs */

const en_cp_form_partnership = /** @type {(inputs: Cp_Form_PartnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnership type`)
};

const id_cp_form_partnership = /** @type {(inputs: Cp_Form_PartnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis kerjasama`)
};

/**
* | output |
* | --- |
* | "Partnership type" |
*
* @param {Cp_Form_PartnershipInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_partnership = /** @type {((inputs?: Cp_Form_PartnershipInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_PartnershipInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_partnership(inputs)
	return en_cp_form_partnership(inputs)
});